// extracted by mini-css-extract-plugin
var _1 = "WidgetContentSkeleton-moduleWidgetContentSkeleton__eblVC";
var _2 = "WidgetContentSkeleton-modulelist__lDSTG Skeleton-moduleSkeleton__Mlrfv";
var _3 = "WidgetContentSkeleton-moduletitle__BGqp3 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "WidgetContentSkeleton", _2 as "list", _3 as "title" }
